module.exports = __webpack_public_path__ + "img/icon-safe2.2f4ff7c5.png";